
import { mapActions } from 'vuex'

import { mdiStar, mdiStarOutline } from '@mdi/js'

export default {
  props: {
    productEntityId: {
      type: Number,
      default: undefined
    },
    isOnWatchList: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mdiStar,
      mdiStarOutline,
      size: 28
    }
  },

  methods: {
    ...mapActions('catalog', ['addToWatchList', 'removeFromWatchList']),
    ...mapActions('product', {
      addToWatchListProduct: 'addToWatchList',
      removeFromWatchListProduct: 'removeFromWatchList'
    }),
    async add () {
      await this.$axios.put(`/private/customer/watchlist/add/${this.productEntityId}`).then(res =>
        this.addToWatchList(this.productEntityId)
      ).then(res =>
        this.addToWatchListProduct()
      )
    },
    async remove () {
      if (this.disabled) { return }
      await this.$axios.delete(`/private/customer/watchlist/remove/${this.productEntityId}`).then(res =>
        this.removeFromWatchList(this.productEntityId)
      ).then(res =>
        this.removeFromWatchListProduct()
      )
    }
  }
}
